import React, { useState } from 'react';
import '../styles/ContributingChunks.css';

/**
 * ContributingChunks component displays the document chunks that contributed to the answer.
 * 
 * @param {Object} props Component props
 * @param {Array} props.chunks Array of document chunks that contributed to the answer
 * @param {string} props.theme Current theme ('light' or 'dark')
 */
function ContributingChunks({ chunks, theme }) {
  const [expandedChunk, setExpandedChunk] = useState(null);
  
  // No chunks to display
  if (!chunks || chunks.length === 0) {
    return (
      <div className={`contributing-chunks-container ${theme}`}>
        <div className="no-chunks-message">
          <span className="material-icons">info</span>
          <span>No contributing document chunks available</span>
        </div>
      </div>
    );
  }

  // Toggle chunk expansion
  const toggleChunkExpansion = (index) => {
    if (expandedChunk === index) {
      setExpandedChunk(null); // Collapse if already expanded
    } else {
      setExpandedChunk(index); // Expand this chunk
    }
  };
  
  // Removed formatRelevanceScore function as it's no longer needed

  return (
    <div className={`contributing-chunks-container ${theme}`}>
      <div className="chunks-header">
        <span className="material-icons">article</span>
        <span>Contributing Document Chunks</span>
        <span className="chunks-count">{chunks.length}</span>
      </div>
      
      <div className="chunks-list">
        {chunks.map((chunk, index) => (
          <div 
            key={index}
            className={`chunk-item ${expandedChunk === index ? 'expanded' : ''}`}
            onClick={() => toggleChunkExpansion(index)}
          >
            <div className="chunk-header">
              <div className="chunk-info">
                <div className="chunk-title">
                  <span className="material-icons">description</span>
                  <span className="chunk-filename">
                    {chunk.filename || 
                     chunk.metadata?.source || 
                     chunk.metadata?.file_name || 
                     chunk.metadata?.filename || 
                     'Unknown file'}
                  </span>
                </div>
                <div className="chunk-metadata">
                  {(chunk.page || chunk.metadata?.page) && (
                    <span className="chunk-page">Page {chunk.page || chunk.metadata?.page}</span>
                  )}
                  {/* Removed relevance score display as requested */}
                </div>
              </div>
              <span className="material-icons expand-icon">
                {expandedChunk === index ? 'expand_less' : 'expand_more'}
              </span>
            </div>
            
            {expandedChunk === index && (
              <div className="chunk-content">
                {chunk.content}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContributingChunks;